import { mediaUrl } from "../lib/api";

/**
 * Circular avatar: shows the user's photo if `url` is set, otherwise the first
 * initial of their name on a coloured disc.
 */
export default function Avatar({
  url,
  name,
  size = 32,
}: {
  url?: string | null;
  name?: string | null;
  size?: number;
}) {
  const initial = (name?.trim()?.charAt(0) || "?").toUpperCase();
  const dim = { width: size, height: size };

  if (url) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={mediaUrl(url) as string}
        alt={name ?? "avatar"}
        style={dim}
        className="flex-shrink-0 rounded-full object-cover"
      />
    );
  }

  return (
    <div
      style={{ ...dim, fontSize: Math.round(size * 0.45) }}
      className="flex flex-shrink-0 items-center justify-center rounded-full bg-ocean-800 font-semibold text-sky-200/80"
    >
      {initial}
    </div>
  );
}
